module.exports = __webpack_public_path__ + "static/cag7-933a1bbecbfcc2c157065e9a5235b4d2.png";